module.exports = __webpack_public_path__ + "img/badge_delivery_master.1dc38bf5.png";